<template>
  <div class="container">
    <div class="row p-0 m-0">
      <div class="col-12 col-lg-10 p-0 m-auto">
        <h2>{{ $t('cartadirector.title') }}</h2>
        <img :src="`${publicPath}img/gerente.jpg`" data-aos="fade" data-aos-duration="1200" class="img-responsive my-3">
        <h4 class="myriadPro">{{ $t('cartadirector.juan') }}</h4>
        <p class="myriadPro text-black"><strong>{{ $t('cartadirector.director') }}</strong></p>
        <img :src="`${publicPath}img/Grupo 1703.png`" class="img-responsive my-3">
        <div class="col-12 col-lg-7 mb-5 m-auto">
          <h6 class="myriadPro">{{ $t('cartadirector.contexto') }}</h6>
        </div>
        <hr class="filigrana  mb-3">
        <div class="col-12 col-lg-10 m-auto text-start">
          <p class=" text-black">{{ $t('cartadirector.si_por') }}</p>
          <p class=" text-black">{{ $t('cartadirector.tras') }}</p>
          <p class=" text-black">{{ $t('cartadirector.gran') }}</p>
          <p class=" text-black">{{ $t('cartadirector.espana') }}</p>
          <p class=" text-black">{{ $t('cartadirector.desde') }}</p>
          <p class=" text-black">{{ $t('cartadirector.durante') }}</p>
          <p class=" text-black">{{ $t('cartadirector.en_cuanto') }}</p>
          <p class=" text-black">{{ $t('cartadirector.incertidumbre') }}</p>
          <p class=" text-black">{{ $t('cartadirector.numeros') }}</p>
          <div class="col-12 col-lg-7 mb-5 m-auto text-center">
            <img :src="`${publicPath}img/Grupo 1703.png`" class="img-responsive my-3">
            <h6 class="myriadPro">{{ $t('cartadirector.enlaera') }}</h6>
          </div>
          <hr class="filigrana">
          <p class=" text-black">{{ $t('cartadirector.respaldo') }}</p>
          <p class=" text-black">{{ $t('cartadirector.bajo') }}</p>
          <p class=" text-black">{{ $t('cartadirector.asi') }}</p>
          <p class=" text-black">{{ $t('cartadirector.ademas') }}</p>
          <p class=" text-black">{{ $t('cartadirector.porque') }}</p>
          <p class=" text-black">{{ $t('cartadirector.poner') }}</p>
          <p class=" text-black">{{ $t('cartadirector.mi') }}</p>
          <p class=" text-black">{{ $t('cartadirector.especial') }}</p>
          <p class=" text-black">{{ $t('cartadirector.todos') }}</p>
          <p class=" text-black">{{ $t('cartadirector.a_todos') }}</p>
          <p>
            <img :src="`${publicPath}img/Grupo 1868.png`" class="img-responsive my-3 ">
          </p>
          <h4 class="myriadPro ">{{ $t('cartadirector.juan') }}</h4>
          <p class="myriadPro  text-black mb-5"><strong>{{ $t('cartadirector.director') }}</strong></p>
        </div>
      </div>

      <!-- NAVEGACIÓ PRE-FOOTER -->
      <hr>
      <div class="row p-0 g-0 mb-3">
        <div class="col-6 p-0 m-0 pb-3 text-start">
          <localized-link class="footerLink" to="/cartas/carta-del-presidente"><img :src="`${publicPath}img/arrowLeft.png`" class="img-responsive arrowsFooter"> {{ $t("nav.carta-del-presidente") }}</localized-link>
        </div>
        <div class="col-6 p-0 m-0 pb-3 text-end textSmall">
          <localized-link class="footerLink" to="/plan-estrategico"> {{ $t("nav.plan-estrategico") }} <img :src="`${publicPath}img/arrowRight.png`" class="img-responsive arrowsFooter"></localized-link>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        publicPath: process.env.BASE_URL
      }
    }
  }
</script>
